import React from 'react';

const Icon: React.FC<any> = ({ className, ...props}) => (
  <svg className={className} {...props} width={12} height={12} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect x="0.5" y="0.5" width={11} height={11} rx="5.5" stroke="black" />
  <path d="M2.22935 5.99941C2.22935 5.95395 2.24741 5.91034 2.27956 5.8782C2.31171 5.84605 2.35532 5.82799 2.40078 5.82799H9.60078C9.64625 5.82799 9.68985 5.84605 9.722 5.8782C9.75415 5.91034 9.77221 5.95395 9.77221 5.99941C9.77221 6.04488 9.75415 6.08848 9.722 6.12063C9.68985 6.15278 9.64625 6.17084 9.60078 6.17084H2.40078C2.35532 6.17084 2.31171 6.15278 2.27956 6.12063C2.24741 6.08848 2.22935 6.04488 2.22935 5.99941Z" fill="#090909" stroke="#090909" strokeWidth="0.857143" />
</svg>

);

export default Icon;
